import template from './author.html';
import controller from './author.controller';
import './author.scss';

let authorComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        author:'='
    },
    template,
    controller
};

export default authorComponent;



// WEBPACK FOOTER //
// ./src/app/components/page/author/author.component.js